<script lang="ts">

    export let text: string = '';
</script>


<div>
    {text}
</div>


<style>
    div {
        /*color: #fb8500;*/
        /*color: #e09f3e;*/
        color: #e85d04;
        /*color: #f4a259;*/
        padding: 2px 4px;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
</style>